var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8892,
    cy: 23.5432,
    r: 23.5432,
    fill: "url(#paint0_radial_10_1383)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9069 35.9633H24.0231V30.2664H16.9069C16.3999 30.2663 15.8988 30.1572 15.4376 29.9465L14.4382 30.2564L11.5697 33.1049L11.3198 34.1043C12.9284 35.319 14.8912 35.9721 16.9069 35.9633Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5008 16.8934H29.5002L32.3487 14.0449L32.4886 12.8356C30.8568 11.3953 28.8848 10.3948 26.7588 9.92855C24.6328 9.46231 22.4231 9.54575 20.3383 10.171C18.2536 10.7962 16.3626 11.9426 14.8441 13.5018C13.3255 15.0611 12.2295 16.9817 11.6597 19.0823C11.977 18.9522 12.3285 18.9311 12.6591 19.0223L18.3561 18.0828C18.3561 18.0828 18.646 17.6031 18.7959 17.633C20.0166 16.2924 21.7035 15.4691 23.5114 15.3316C25.3193 15.1941 27.1114 15.7528 28.5207 16.8934H28.5008Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4066 19.0824C35.7518 16.6713 34.4075 14.5038 32.5386 12.8457L28.5407 16.8436C29.3739 17.5244 30.0417 18.3855 30.4935 19.362C30.9454 20.3385 31.1697 21.4048 31.1493 22.4806V23.1902C31.6166 23.1902 32.0793 23.2823 32.511 23.4611C32.9427 23.6399 33.3349 23.902 33.6653 24.2324C33.9957 24.5628 34.2578 24.955 34.4366 25.3867C34.6154 25.8184 34.7075 26.2811 34.7075 26.7483C34.7075 27.2156 34.6154 27.6783 34.4366 28.11C34.2578 28.5417 33.9957 28.9339 33.6653 29.2643C33.3349 29.5947 32.9427 29.8568 32.511 30.0356C32.0793 30.2144 31.6166 30.3065 31.1493 30.3065H24.0331L23.3235 31.0261V35.2938L24.0331 36.0035H31.1493C33.1365 36.0189 35.0759 35.3944 36.6806 34.2222C38.2853 33.05 39.4701 31.3924 40.0597 29.4946C40.6494 27.5969 40.6125 25.5597 39.9546 23.6845C39.2967 21.8094 38.0526 20.1958 36.4066 19.0824Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9071 17.4832C14.9789 17.4947 13.1025 18.1082 11.5399 19.2379C9.97733 20.3676 8.8066 21.9571 8.19124 23.7845C7.57588 25.6119 7.54663 27.5858 8.10757 29.4306C8.6685 31.2754 9.79162 32.8989 11.32 34.0744L15.4479 29.9466C14.9233 29.7096 14.4641 29.3489 14.1096 28.8954C13.7551 28.4419 13.5159 27.9092 13.4125 27.3429C13.3092 26.7767 13.3448 26.1938 13.5162 25.6443C13.6877 25.0948 13.9898 24.5951 14.3969 24.1881C14.8039 23.7811 15.3036 23.4789 15.8531 23.3075C16.4025 23.136 16.9854 23.1004 17.5517 23.2038C18.1179 23.3071 18.6507 23.5463 19.1042 23.9008C19.5577 24.2553 19.9184 24.7146 20.1554 25.2391L24.2832 21.1113C23.4168 19.9787 22.3001 19.0618 21.0205 18.4324C19.7409 17.803 18.3331 17.4781 16.9071 17.4832Z",
    fill: "#FBBC05"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10_1383",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.328 10.969) rotate(52.6646) scale(92.1962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloud);
export default __webpack_public_path__ + "static/media/google-cloud.4474ce30de2a56096cf1af976a35d8a9.svg";
export { ForwardRef as ReactComponent };